import { render } from "./GastosPorAno.vue?vue&type=template&id=3a243d86&scoped=true"
import script from "./GastosPorAno.vue?vue&type=script&lang=js"
export * from "./GastosPorAno.vue?vue&type=script&lang=js"

import "./GastosPorAno.vue?vue&type=style&index=0&id=3a243d86&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a243d86"]])

export default __exports__